import styled from 'styled-components';

export const LoginLogo = styled.div`
  display: flex;
  align-content: center;
  flex-direction: column;
`;

export const LoginLogoSpan = styled.span`
  margin: 0 -3px;
  font-size: 18px;
  font-weight: 300;  
`;

export const LoginForm = styled.form`
  width: 100%;  
  padding: 118px 26px 0 26px;
  box-sizing: border-box;
  @media (max-width: 426px) {
    padding: 90px 26px 0 26px;
  }
`;

export const FormField = styled.div`
  margin-bottom: 20px;

  & > button {
    width: 100%;
  }
`;

export const LabelForm = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LoginLink = styled.div`
  display: flex;
  margin: 16px 0;
  font-size: 18px;
  font-weight: 300;
  text-align: center;
  font-style: normal;
  align-items: center;
  justify-content: center;
  font-family: 'Proxima Nova';
`;

export const Border = styled.div`
  height: 2px;
  Width: 172px;
  /* background-color: #EBEDF2; */
  border-bottom: 1px solid #EBEDF2;
`;

export const Or = styled.div`
  margin: 0 5px;
`;

export const MembershipSection = styled.div`
  width: 305px;
  font-weight: 400;
`;

export const MembershipMessage = styled.div`
  padding: 25px 40px;
  border-bottom: solid 1px var(--LightGray);
`;

export const MembershipButton = styled.div``;

export const CloseModalButton = styled.div`
  margin: 16px 40px 21px 40px;
  height: 40px;
  background-color: var(--PrimaryBlue);
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
`;

export const ModalBackground = styled.div`
  z-index: -1;
`;

export const Hyperlink = styled.span`
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;